import { render, staticRenderFns } from "./ThreeStepProcess.vue?vue&type=template&id=52a31b86&"
import script from "./ThreeStepProcess.vue?vue&type=script&lang=js&"
export * from "./ThreeStepProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports